<template>
  <v-dialog v-model="dialog" width="1200" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn :depressed="depressed" :color="color" :title="title" v-bind="attrs" v-on="on">
        <v-icon v-if="icon" left>{{ icon }}</v-icon>
        {{ name }}
      </v-btn>
    </template>

    <div class="position-relative">
      <component :is="component" @close="onClose" @loading="onLoading" />
      <div v-if="!persistent" class="vuedl-layout__closeBtn" @click="onClose">
        ×
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "Modal",
  props: {
    depressed: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: "primary",
    },

    title: {
      type: String,
      default: "",
    },

    icon: {
      type: String,
      default: "",
    },

    name: {
      type: String,
      default: "Действие",
    },

    component: {},
  },

  data: () => ({
    dialog: false,
    persistent: false,
  }),

  methods: {
    async onClose(askBeforeClose = false) {
      if (typeof askBeforeClose === "boolean" && askBeforeClose) {
        const res = await this.$dialog.confirm({
          text: "Вы уверены, что хотите закрыть это окно?",
          title: "Внимание",
          actions: {
            false: "Нет",
            true: {
              text: "Да",
              color: "primary",
            },
          },
        });
        if (!res) {
          return;
        }
      }
      this.dialog = false;
      this.persistent = false;
    },

    onLoading(val) {
      this.persistent = val;
    },
  },
};
</script>

<style scoped></style>
